var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0909 0C9.59891 0 7.59691 2.00008 7.59691 4.41812V4.95532H2.54545C1.84418 4.95532 1.27273 5.50728 1.27273 6.18463V7.41393H0V9.87254H2.54545V28.3121C2.54545 30.3343 4.27 32 6.36364 32H21.6364C23.73 32 25.4545 30.3343 25.4545 28.3121V9.87254H28V7.41393H26.7273V6.18463C26.7273 5.50728 26.1558 4.95532 25.4545 4.95532H20.4031V4.41689C20.4031 2.00008 18.4011 0 15.9091 0H12.0909ZM12.0909 2.53482H15.9091C16.9324 2.53482 17.7787 3.34125 17.7787 4.41689V4.95532H10.22V4.41689C10.22 3.34125 11.0664 2.53605 12.0896 2.53605L12.0909 2.53482ZM5.09091 9.87254H11.6136C11.7715 9.88852 11.928 9.91064 12.0909 9.91064H15.9091C16.072 9.91064 16.2273 9.88852 16.3864 9.87254H22.9091V28.3121C22.9091 29.0042 22.3529 29.5414 21.6364 29.5414H6.36364C5.64709 29.5414 5.09091 29.0042 5.09091 28.3121V9.87254ZM7.63636 12.3311V27.0828H10.1818V12.3311H7.63636ZM12.7273 12.3311V27.0828H15.2727V12.3311H12.7273ZM17.8182 12.3311V27.0828H20.3636V12.3311H17.8182Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e515b265f4baab411f8edd986ce98e92.svg";
export { ForwardRef as ReactComponent };